export const PRIMARY_COLOR = "#002D96";
export const WHITE_COLOR = "#FFF";
export const LIGHT_GRAY = "#909090";
export const LIGHT_TEXT_GRAY = "#666666";
export const PRIMARY_HOVER_COLOR = "#4160a7";
export const YELLOW_COLOR = "#EEBB4D";

export const LIGHT_GARY_COLOR_TRASN = "#22222266";

export const SUCCESS_COLOR = "#00AA06";
export const WARNING_COLOR = "#F1B800";
export const ERROR_COLOR = "#FF0000";

export const SECONDARY_COLOR = "#003657";
export const GRAY_COLOR = "#555555";
export const LIGHT_GRAY_COLOR = "#777777";
export const TRANSPARENT_WHITE_COLOR = "#FFFFFF88";
